import { Dialog, DialogContent, DialogTitle, Divider, Grid, IconButton, Typography, useMediaQuery } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useTransactionWalletMutation } from "src/_api/mapitShipApi";
import { Clear } from "@mui/icons-material";
import SelectAmountCard from "../views/AccountBalance/components/SelectAmountCard";

export default function ChargeBalanceDialog({
    open,
    onClose,
}) {
    const { t } = useTranslation()

    const chargeValues = [100, 500, 1000, 2000, 5000]

    //======= Charge Wallet =========

    const [chargeWallet, { isLoading: chargeWalletLoading, error: chargeWalletError, isSuccess: chargeWalletIsSuccess }] = useTransactionWalletMutation()

    const onConfirm = async (value) => {
        try {
            const totaLCharge = Number((value + (value * 0.15)).toFixed(2))
            let response = await chargeWallet({ amount: totaLCharge, vat: value * 0.15, lastPageUrl: `${window.location.pathname}${window.location.search}` }).unwrap()
            if (!!response?.url) {
                window.open(response?.url, "_self")
            }
        } catch (error) {
            console.log(error)
        }
    }

    const fullScreen = useMediaQuery(theme => theme.breakpoints.down('md'));

    const isLoading = chargeWalletLoading
    const error = chargeWalletError
    const isSuccess = chargeWalletIsSuccess

    return (
        <Dialog
            open={open}
            fullWidth
            maxWidth="md"
            fullScreen={fullScreen}
            onClose={(e) => e.preventDefault()}
        >
            <DialogTitle sx={{ display: "flex", alignItems: "center" }}>
                {t("Charge Amount")}
                <IconButton sx={{ ml: "auto" }} onClick={onClose} color="primary">
                    <Clear />
                </IconButton>
            </DialogTitle>
            <Divider />
            <DialogContent>
                <Grid container spacing={2} alignItems="center">
                    <Grid item xs={12} sm={6} md={4} lg={3} key={"CUSTOM"}>
                        <SelectAmountCard custom={true} onConfirm={onConfirm} loaidng={isLoading} />
                    </Grid>
                    {
                        chargeValues.map((value, index) => (
                            <Grid item xs={12} sm={6} md={4} lg={3} key={value}>
                                <SelectAmountCard key={value} value={value} onConfirm={onConfirm} loaidng={isLoading} />
                            </Grid>
                        ))
                    }
                </Grid>
            </DialogContent>
            <DialogContent>
                {isSuccess && <Typography color="success.main">{t("Done successfully")}</Typography>}
                {!!error && <Typography color="error">{error}</Typography>}
            </DialogContent>
        </Dialog>
    )
}

// import { Dialog, DialogContent, DialogTitle, Divider, IconButton, useMediaQuery } from "@mui/material";
// import { useTranslation } from "react-i18next";
// import { Clear } from "@mui/icons-material";
// import { ChargeWalletWithAmount } from "../views/AccountBalance/components";

// export default function ChargeBalanceDialog({
//     open,
//     onClose,
// }) {
//     const { t } = useTranslation()

//     //======= Charge Wallet =========
//     const fullScreen = useMediaQuery(theme => theme.breakpoints.down('md'));

//     return (
//         <Dialog
//             open={open}
//             fullWidth
//             maxWidth="md"
//             fullScreen={fullScreen}
//             onClose={(e) => e.preventDefault()}
//         >
//             <DialogTitle sx={{ display: "flex", alignItems: "center" }}>
//                 {t("Charge Amount")}
//                 <IconButton sx={{ ml: "auto" }} onClick={onClose} color="primary">
//                     <Clear />
//                 </IconButton>
//             </DialogTitle>
//             <Divider />
//             <DialogContent>
//                 <ChargeWalletWithAmount
//                     chargeValues={[100, 500, 1000, 2000, 5000]}
//                 />
//             </DialogContent>
//         </Dialog>
//     )
// }
